import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardBody } from './PropertyCardBody.styles';

/**
 * Used to add card styles and behaviors to the `PropertyCard`. Extends `Card`.
 *
 * @extends Card
 * @since 8.63.0
 */
export var PropertyCardBody = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardBody, _extends({
    ref: forwardedRef,
    appearance: "borderless",
    cardType: "secondary"
    /* Override role="button" applied by Card. Can't have buttons inside of a button. */,
    role: undefined
  }, props));
});
PropertyCardBody.displayName = 'PropertyCard.Body';